@if(isProfileIncomplete() || forceShow) {
    <div class="PGCompleteProfile bg-light">
        <div class="PGCompleteProfile-Inner card container">
            <div class="card-body">
                <h4 class="card-title pb-3 border-bottom mb-3">
                    <i class="fa-regular fa-user opacity-80 me-3"></i>
                    <span>{{ 'pg-complete-profile.title' | locTranslate }}</span>
                </h4>
                <div class="card-text">
                    <div class="mb-3">{{ 'pg-complete-profile.text-' + getMode() | locTranslate }}</div>
                    <app-pg-profile-editor (onSave)="onSave.emit()"></app-pg-profile-editor>
                </div>
            </div>
        </div>
    </div>
}